/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowRoundSyncForwardIcon16Solid = forwardRef('ArrowRoundSyncForwardIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M13 1.779a1 1 0 1 1 2 0v4.225a1 1 0 0 1-1 1h-3.764a1 1 0 0 1 0-2h1.767a5 5 0 0 0-8.715 1.324 1 1 0 1 1-1.885-.669A7 7 0 0 1 13 3.101V1.779Z" }),
        React.createElement("path", { d: "M3 14.221a1 1 0 1 1-2 0V9.996a1 1 0 0 1 1-1h3.764a1 1 0 1 1 0 2H3.997a4.999 4.999 0 0 0 8.716-1.327 1 1 0 1 1 1.886.667A7 7 0 0 1 3 12.9v1.322Z" })));
});
